import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateJobAlias } from "../actions/updateJobAlias";

interface Props {
  jobId: number | string;
  alias: string | null;
}

export const useUpdateJobAliasMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: Props) => updateJobAlias(payload),

    onSuccess: (_updatedJob, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["jobs"],
      });

      queryClient.invalidateQueries({
        queryKey: ["job", String(variables.jobId)],
      });

      queryClient.invalidateQueries({
        queryKey: ["jobs-by-id", String(variables.jobId)],
      });

      queryClient.invalidateQueries({
        queryKey: ["widget-jobs"],
      });
    },
  });
};
